var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlimitedInfinity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3 3 18 18",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Unlimited") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 1,
    height: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 1,
    height: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 1,
    height: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 1,
    height: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 9,
    width: 1,
    height: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 9,
    width: 1,
    height: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 9,
    width: 1,
    height: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 9,
    width: 1,
    height: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 1,
    height: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 1,
    height: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 10,
    width: 1,
    height: 1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 10,
    width: 1,
    height: 1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 11,
    width: 1,
    height: 1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 1,
    height: 1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 1,
    height: 1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 11,
    width: 1,
    height: 1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 1,
    height: 1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12,
    width: 1,
    height: 1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 1,
    height: 1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 12,
    width: 1,
    height: 1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 13,
    width: 1,
    height: 1
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13,
    width: 1,
    height: 1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 1,
    height: 1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 13,
    width: 1,
    height: 1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 1,
    height: 1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 14,
    width: 1,
    height: 1
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 1,
    height: 1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14,
    width: 1,
    height: 1
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 1,
    height: 1
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 14,
    width: 1,
    height: 1
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 1,
    height: 1
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 14,
    width: 1,
    height: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlimitedInfinity);
export default __webpack_public_path__ + "static/media/unlimited-infinity.d7acc2104f6232915e2cf5dcae69580f.svg";
export { ForwardRef as ReactComponent };